/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./geoDetails.vue?vue&type=template&id=45a7f306&scoped=true"
import script from "./geoDetails.vue?vue&type=script&lang=js"
export * from "./geoDetails.vue?vue&type=script&lang=js"
import style0 from "./geoDetails.vue?vue&type=style&index=0&id=45a7f306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a7f306",
  null
  
)

export default component.exports